import { Content, Text, Anchor } from '@kinesis/bungle';
import { noop } from 'lodash/fp';

const DownloadLink = (props: DownloadLinkProps) => {
  const { onDownload = noop } = props;

  return (
    <Content padding='none'>
      <Text>
        <Anchor as='button' type='button' onClick={onDownload}>
          Download the complete data
        </Anchor>
        &nbsp;for more details and to compare this pathway with alternatives.
      </Text>
    </Content>
  );
};

export type DownloadLinkProps = {
  onDownload?: () => void;
};

export { DownloadLink };
